import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource, paramsToString } from "./BaseResource";
class EmbeddedProductFieldResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.applicationId = undefined;
        this.externalCode = undefined;
        this.schemaMetadata = undefined;
        this.fields = undefined;
    }
    pk(parent, key) {
        return `${this.applicationId?.toString()}/${this.externalCode}`;
    }
    static url(urlParams) {
        const { applicationId, externalCode, ...searchParams } = urlParams;
        const url = super.url(urlParams);
        return `${url}${paramsToString(searchParams)}`;
    }
}
EmbeddedProductFieldResource.calcPathToFields = "fields";
EmbeddedProductFieldResource.calcPathToValue = "value";
EmbeddedProductFieldResource.urlRoot = apiResourceUrl("ep-field");
export { EmbeddedProductFieldResource };
//# sourceMappingURL=EmbeddedProductFieldResource.js.map